<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel">
            <div class="modal__logo-wrapper">
                <div class="modal__logo"></div>
                <!-- <div class="modal__logo-title">Seguro Desk</div> -->
            </div>

            <div class="modal__main-icon modal__main-icon--private"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form">
                <form class="add__form">
                    <transition name="fade" mode="out-in">
                        <Loading v-if="formLoading" />
                        <div v-else class="add__content">
                            <transition name="fade" mode="out-in">
                                <div class="details" key="0">

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <VSelect :options="memberTypes" :reduce="(type) => type.id"
                                                placeholder="Type" label="value" v-model="customerDetails.type"
                                                class="select select--default" />
                                        </div>

                                        <div class="form__field form__field--double">
                                            <VSelect :options="languages" :reduce="(language) => language.id"
                                                :placeholder="$t('addPrivateCostumerModal.languagePlaceholder')"
                                                label="name" v-model="customerDetails.language"
                                                class="select select--default"
                                                :class="{ 'select--error': languageHasError }" />
                                            <div class="form__error" v-if="languageHasError">
                                                {{ $t(`addPrivateCostumerModal.${"languageErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field" v-if="customerDetails.type == 1">
                                        <input type="text" class="input input--default" placeholder="Company *"
                                            v-model="customerDetails.company"
                                            :class="{ 'input--error': companyHasError }" />
                                        <div class="form__error" v-if="companyHasError">
                                            {{ $t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`) }}
                                        </div>
                                    </div>

                                    <div v-else>
                                        <div class="form__field">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.firstNamePlaceholder') + ' *'"
                                                v-model="customerDetails.firstName" :class="{
                                                    'input--error': firstNameHasError,
                                                }" />
                                            <div class="form__error" v-if="firstNameHasError">
                                                {{ $t(`addPrivateCostumerModal.${"firstNameErrorMsg"}`) }}
                                            </div>
                                        </div>

                                        <div class="form__field">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.lastNamePlaceholder') + ' *'"
                                                v-model="customerDetails.lastName"
                                                :class="{ 'input--error': lastNameHasError }" />
                                            <div class="form__error" v-if="lastNameHasError">
                                                {{ $t(`addPrivateCostumerModal.${"lastNameErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.streetPlaceholder')"
                                                v-model="customerAdresses[0].street" :class="{
                                                    'input--error': streetHasError,
                                                }" />
                                            <div class="form__error" v-if="streetHasError">
                                                {{ $t(`addPrivateCostumerModal.${"streetErrorMsg"}`) }}
                                            </div>
                                        </div>
                                        <div class="form__field">
                                            <input type="text" class="input input--default input--nr" placeholder="Nr."
                                                v-model="customerAdresses[0].number" />
                                        </div>
                                    </div>

                                    <div class="form__row">
                                        <div class="form__field form__field--double">
                                            <input type="text" class="input input--default" placeholder="PLZ"
                                                v-model="customerAdresses[0].zip"
                                                :class="{ 'input--error': zipHasError }" />

                                            <div class="form__error" v-if="zipHasError">
                                                {{ zipCodePlaceholder }}
                                            </div>
                                        </div>
                                        <div class="form__field form__field--double">
                                            <VSelect v-if="zipCodeData.length > 1" :options="zipCodeData"
                                                :reduce="(city) => city.city"
                                                :placeholder="$t('addPrivateCostumerModal.cityPlaceholder')"
                                                label="city" v-model="customerAdresses[0].city"
                                                class="select select--default" :class="{
                                                    'select--error': cityHasError,
                                                }" />

                                            <div v-else-if="zipCodeData.length"
                                                class="input input--default input--readonly"
                                                :class="{ 'input--error': cityHasError }">
                                                {{ customerAdresses[0].city }}
                                            </div>

                                            <input v-else-if="!zipCodeData.length" type="text"
                                                class="input input--default"
                                                :placeholder="$t('addPrivateCostumerModal.cityPlaceholder')"
                                                v-model="customerAdresses[0].city"
                                                :class="{ 'input--error': cityHasError }" />

                                            <div class="form__error" v-if="cityHasError">
                                                {{ $t(`addPrivateCostumerModal.${"cityErrorMsg"}`) }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <div class="form__input-wrapper" v-for="(email, index) in customerEmails"
                                            :key="index">
                                            <input type="text" class="input input--default" placeholder="E-mail *"
                                                @input="validateEmail($event, index)" :value="email.email" :class="{
                                                    'input--error': email.hasError,
                                                }" />
                                            <div class="form__add" v-if="index === 0 && email.email"
                                                @click="addInput('email')"></div>
                                            <div class="form__remove" v-else-if="index !== 0"
                                                @click="removeInput('email', email.id, index)"></div>
                                            <div class="form__error" v-if="email.hasError">
                                                {{ email.errorPlaceholder }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form__field form__field--prefix">
                                        <div class="form__row" v-for="(phone, index) in customerPhones" :key="index">

                                            <div class="form__input-wrapper">
                                                <input type="text" class="input input--default"
                                                    :placeholder="$t('addPrivateCostumerModal.phonePlaceholder') + ' *'"
                                                    @input="validatePhone($event, index)" :value="phone.phone" :class="{
                                                        'input--error': phone.hasError,
                                                    }" />
                                                <div class="form__add" v-if="index === 0 && phone.phone"
                                                    @click="addInput('phone')"></div>
                                                <div class="form__remove" v-else-if="index !== 0"
                                                    @click="removeInput('phone', phone.id, index)"></div>
                                                <div class="form__error" v-if="phone.hasError">
                                                    {{ phone.errorPlaceholder }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form__field">
                                        <VSelect :options="teams" :reduce="(team) => team.id"
                                            :placeholder="$t('addPrivateCostumerModal.teamsPlaceholder')" label="name"
                                            v-model="customerDetails.teamId" class="select select--default"
                                            :class="{ 'select--error': teamHasError }" />
                                        <div class="form__error" v-if="teamHasError">
                                            {{ $t(`addPrivateCostumerModal.${"teamErrorMsg"}`) }}
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </transition>
                </form>
            </div>
            <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading">
            </div>


            <button v-else type="button" class="modal__button modal__button--submit button button--default"
                @click="createCustomer()">
                <span>{{ $t(`addPrivateCostumerModal.${"save"}`) }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "@/partials/Loading";
import statics from "@/statics";
import parseFieldErrors from "@/helpers/parseFieldErrors";

export default {
    name: "LeadCustomerModal",
    components: {
        Loading,
    },

    data() {
        return {
            statics,
            parseFieldErrors,
            formLoading: false,
            isRequesting: false,

            emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,


            showTeams: false,

            customerDetails: {
                gender: "",
                titleId: "",
                firstName: "",
                lastName: "",
                language: "",
                teamId: "",
                type: 2,
                company: "",
            },

            memberTypes: [
                { id: 1, value: "Firma" },
                { id: 2, value: "Privat" },
            ],

            customerAdresses: [
                {
                    street: "",
                    number: "",
                    city: "",
                    zip: "",
                },
            ],

            customerEmails: [
                {
                    email: "",
                    hasError: false,
                    errorPlaceholder: "",
                },
            ],

            customerPhones: [
                {
                    prefix: "",
                    phone: "",
                    hasError: false,
                    errorPlaceholder: "",
                },
            ],

            firstNameHasError: false,
            lastNameHasError: false,
            companyHasError: false,

            languageHasError: false,

            emailHasError: false,
            phoneHasError: false,

            teamHasError: false,

            zipHasError: false,
            cityHasError: false,
            streetHasError: false,
            zipCodePlaceholder: "",

            customerInitialTeam: null,

            specificErrors: [],

            customerEditId: null,
        };
    },

    watch: {
        "customerDetails.teamId"(value) {
            if (value) {
                this.teamHasError = false;
            } else {
                this.teamHasError = true;
            }
        },

        "customerDetails.firstName"(value) {
            if (value) {

                this.firstNameHasError = false;

            } else {
                this.firstNameHasError = true;
            }
        },

        "customerDetails.lastName"(value) {
            if (value) {

                this.lastNameHasError = false;

            } else {
                this.lastNameHasError = true;
            }
        },

        "customerDetails.language"(value) {
            if (value) {
                this.languageHasError = false;
            } else {
                this.languageHasError = true;
            }
        },

        "customerDetails.company"(value) {
            if (value) {
                this.companyHasError = false;
            } else {
                this.companyHasError = true;
            }
        },

        async zip(zip) {
            if (zip) {
                this.zipHasError = false;
                this.zipCodePlaceholder = "";

                if (Number(zip) >= 1000 && Number(zip) <= 9999) {
                    await this.loadCities(zip);
                } else {
                    this.zipCodeData = [];
                    this.customerAdresses[0].city = "";
                    this.zipHasError = true;
                    this.zipCodePlaceholder = this.$t(`addPrivateCostumerModal.${"invalidZip"}`);
                }
            }
        },

        specificErrors(errors) {
            const errorKeys = errors.map((error) => error.errorKey);

            if (errorKeys.includes("email")) {
                errors.forEach((error) => {
                    if (error.errorKey === "email") {
                        this.customerEmails[error.errorPos].errorPlaceholder =
                            error.errorValue;
                        this.customerEmails[error.errorPos].hasError = true;
                    }
                });
            } else {
                this.customerEmails.forEach((email) => {
                    email.errorPlaceholder = "";
                    email.hasError = false;
                });
            }

            if (errorKeys.includes("phone")) {
                errors.forEach((error) => {
                    if (error.errorKey === "phone") {
                        this.customerPhones[error.errorPos].errorPlaceholder =
                            error.errorValue;
                        this.customerPhones[error.errorPos].hasError = true;
                    }
                });
            } else {
                this.customerPhones.forEach((phone) => {
                    phone.errorPlaceholder = "";
                    phone.hasError = false;
                });
            }

            if (errorKeys.includes("first_name")) {
                this.firstNameHasError = true;
            } else {
                this.firstNameHasError = false;
            }

            if (errorKeys.includes("last_name")) {
                this.lastNameHasError = true;
            } else {
                this.lastNameHasError = false;
            }
        },
    },

    async mounted() {
        this.formLoading = true;

        if (!(this.$checkRolePermission('customer_create') || this.$checkRolePermission('customer_edit'))) {
            this.closeModal();
        } else {

            const customer_status_id = 2;
            await this.$store.dispatch("getCustomerForms", { customer_status_id });
            if (!this.leadCustomerToEdit && this.languages && this.languages.length) {
                this.customerDetails.language = this.languages[1].id;
            }

            if (this.customerForms.teams.length > 0) {
                this.showTeams = (this.loggedUser && this.loggedUser.is_super_admin && !this.editingCustomer);
            }

            if (this.leadCustomerToEdit) {
                this.loadFieldsForEdit(this.leadCustomerToEdit);
            }
        }
        this.formLoading = false;
    },

    computed: {
        ...mapGetters([
            "customerForms",
            "customer",
            "language",
            "loggedUser",
            "leadCustomerToEdit"
        ]),

        languages() {
            return this.customerForms.languages;
        },

        teams() {
            return this.customerForms.teams;
        },
        phonePrefixes() {
            return this.customerForms.prefixes.map((prefix) => prefix.phone_prefix);
        },

        zipCodeData: {
            get() {
                return this.$store.state.zipCodes.zipCodeData;
            },
            set(value) {
                this.$store.commit("setZipCodeData", value);
            },
        },

        zip() {
            return this.customerAdresses[0].zip;
        },
        city() {
            return this.customerAdresses[0].city;
        },
        street() {
            return this.customerAdresses[0].street;
        },
    },

    methods: {
        closeModal() {
            this.$store.commit("setLeadCustomerToEdit", null);
            this.$store.commit("setShowCustomerLeadModal", false);
            this.zipCodeData = [];
        },

        loadFieldsForEdit(customer) {
            this.customerEditId = customer.id;
            this.customerDetails.teamId = customer.team ? customer.team.id : "";

            this.customerInitialTeam = customer.team ? customer.team.id : "";
            this.customerDetails.type = customer.member_type ? customer.member_type.id : "";
            this.customerDetails.company = customer.company_name || "";
            this.customerDetails.firstName = customer.first_name || "";
            this.customerDetails.lastName = customer.last_name || "";
            this.customerDetails.language = customer.language.id || "";
            this.customerAdresses[0].id = customer.customer_addresses.length
                ? customer.customer_addresses[0].id
                : "";
            this.customerAdresses[0].street = customer.customer_addresses.length
                ? customer.customer_addresses[0].street
                : "";

            this.customerAdresses[0].zip = customer.customer_addresses.length
                ? customer.customer_addresses[0].zip
                : "";
            this.customerAdresses[0].number = customer.customer_addresses.length
                ? customer.customer_addresses[0].number
                : "";
            this.customerAdresses[0].city = customer.customer_addresses.length
                ? customer.customer_addresses[0].city
                : "";
            this.customerEmails = customer.customer_emails.length
                ? customer.customer_emails.map((email) => ({
                    id: email.id,
                    email: email.email,
                    hasError: false,
                    errorPlaceholder: "",
                }))
                : [
                    {
                        id: "",
                        email: "",
                        hasError: false,
                        errorPlaceholder: "",
                    },
                ];
            this.customerPhones = customer.customer_phones.length
                ? customer.customer_phones.map((phone) => ({
                    id: phone.id,
                    prefix: phone.prefix,
                    phone: phone.phone,
                    hasError: false,
                    errorPlaceholder: "",
                }))
                : [
                    {
                        id: "",
                        prefix: "",
                        phone: "",
                        hasError: "",
                        errorPlaceholder: "",
                        prefixHasError: "",
                        prefixErrorPlaceholder: "",
                    },
                ];
        },

        validateCustomerDetails() {
            const {
                firstName,
                lastName,
                language,
                teamId,
                type,
                company
            } = this.customerDetails;

            const { zip, city } = this.customerAdresses[0];

            if (type == 2) {
                this.firstNameHasError = !firstName;
                this.lastNameHasError = !lastName;
                this.companyHasError = false;
            } else if (type == 1) {
                this.companyHasError = !company;
                this.firstNameHasError = false;
                this.lastNameHasError = false;
            }

            this.languageHasError = !language;
            this.teamHasError = !teamId;

            if (zip) {
                if (!(Number(zip) >= 1000 && Number(zip) <= 9999)) {
                    this.zipHasError = true;
                    this.zipCodePlaceholder = "Invalid zip code";
                } else {
                    this.zipHasError = false;
                    this.zipCodePlaceholder = "";
                }

                this.cityHasError = !city;
            } else {
                this.zipHasError = false;
                this.zipCodePlaceholder = "";
                this.cityHasError = false;
            }

            this.streetHasError = false;

            return !(
                this.firstNameHasError ||
                this.lastNameHasError ||
                this.companyHasError ||
                this.languageHasError ||
                this.zipHasError ||
                this.cityHasError ||
                this.teamHasError
            );
        },

        validateCustomerContact() {
            this.customerEmails = [...this.customerEmails];
            this.customerPhones = [...this.customerPhones];

            const anyEmailEntered = this.customerEmails.some(
                (e) => e.email && String(e.email).trim() !== ""
            );

            const anyPhoneEntered = this.customerPhones.some(
                (p) => p.phone && String(p.phone).trim() !== ""
            );

            if (!anyEmailEntered && !anyPhoneEntered) {
                if (!this.customerEmails.length) {
                    this.customerEmails = [{
                        email: "",
                        hasError: true,
                        errorPlaceholder: this.$t(`addPrivateCostumerModal.${"phoneOrEmailRequired"}`)
                    }];
                } else {
                    this.customerEmails[0].hasError = true;
                    this.customerEmails[0].errorPlaceholder = this.$t(`addPrivateCostumerModal.${"phoneOrEmailRequired"}`);
                }

                if (!this.customerPhones.length) {
                    this.customerPhones = [{
                        phone: "",
                        hasError: true,
                        errorPlaceholder: this.$t(`addPrivateCostumerModal.${"phoneOrEmailRequired"}`)
                    }];
                } else {
                    this.customerPhones[0].hasError = true;
                    this.customerPhones[0].errorPlaceholder = this.$t(`addPrivateCostumerModal.${"phoneOrEmailRequired"}`);
                }

                this.customerEmails = [...this.customerEmails];
                this.customerPhones = [...this.customerPhones];

                return false;
            }

            this.customerEmails.forEach((e) => {
                if (e.email && String(e.email).trim() !== "") {
                    if (!this.emailRegex.test(String(e.email).toLowerCase())) {
                        e.hasError = true;
                        e.errorPlaceholder = this.$t(`addPrivateCostumerModal.${"invalidEmail"}`);
                    } else {
                        e.hasError = false;
                        e.errorPlaceholder = "";
                    }
                } else {
                    e.hasError = false;
                    e.errorPlaceholder = "";
                }
            });

            this.customerPhones.forEach((p) => {
                if (p.phone && String(p.phone).trim() !== "") {
                    if (!this.statics.phoneRegex.test(String(p.phone))) {
                        p.hasError = true;
                        p.errorPlaceholder = this.$t(`addPrivateCostumerModal.${"invalidPhone"}`);
                    } else {
                        p.hasError = false;
                        p.errorPlaceholder = "";
                    }
                } else {
                    p.hasError = false;
                    p.errorPlaceholder = "";
                }
            });

            this.customerEmails = [...this.customerEmails];
            this.customerPhones = [...this.customerPhones];

            const hasEmailErrors = this.customerEmails.some(e => e.hasError);
            const hasPhoneErrors = this.customerPhones.some(p => p.hasError || p.prefixHasError);

            return !(hasEmailErrors || hasPhoneErrors);
        },

        validateEmail(event, index) {
            const { value } = event.target;
            this.customerEmails[index].email = value;
            if (this.customerEmails[index].email) {
                if (!this.emailRegex.test(this.customerEmails[index].email.toLowerCase())) {
                    this.customerEmails[index].hasError = true;
                    this.customerEmails[index].errorPlaceholder = this.$t(`addPrivateCostumerModal.${"invalidEmail"}`);
                } else {
                    this.customerEmails[index].hasError = false;
                    this.customerEmails[index].errorPlaceholder = "";
                }
            } else {
                this.customerEmails[index].hasError = false;
                this.customerEmails[index].errorPlaceholder = "";
            }

            const anyEmailEntered = this.customerEmails.some(
                (e) => e.email && String(e.email).trim() !== ""
            );
            if (anyEmailEntered) {
                this.customerPhones.forEach((p) => {
                    if (p.errorPlaceholder === this.$t(`addPrivateCostumerModal.${"phoneOrEmailRequired"}`)) {
                        p.hasError = false;
                        p.errorPlaceholder = "";
                    }
                });
                this.customerPhones = [...this.customerPhones];
            }

            this.customerEmails = [...this.customerEmails];
        },

        validatePrefix(value, index) {
            this.customerPhones[index].prefix = value;
            if (!this.customerPhones[index].prefix) {
                this.customerPhones[index].prefixHasError = true;
                this.customerPhones[index].prefixErrorPlaceholder = this.$t(`addPrivateCostumerModal.${"invalidPrefix"}`);
            } else {
                this.customerPhones[index].prefixHasError = false;
                this.customerPhones[index].prefixErrorPlaceholder = "";
            }
        },

        validatePhone(event, index) {
            const { value } = event.target;
            this.customerPhones[index].phone = value;
            if (this.customerPhones[index].phone) {
                if (!this.statics.phoneRegex.test(value)) {
                    this.customerPhones[index].hasError = true;
                    this.customerPhones[index].errorPlaceholder = this.$t(`addPrivateCostumerModal.${"invalidPhone"}`);
                } else {
                    this.customerPhones[index].hasError = false;
                    this.customerPhones[index].errorPlaceholder = "";
                }
            } else {
                this.customerPhones[index].hasError = false;
                this.customerPhones[index].errorPlaceholder = "";
            }

            const anyPhoneEntered = this.customerPhones.some(
                (p) => p.phone && String(p.phone).trim() !== ""
            );
            if (anyPhoneEntered) {
                this.customerEmails.forEach((e) => {
                    if (e.errorPlaceholder === this.$t(`addPrivateCostumerModal.${"phoneOrEmailRequired"}`)) {
                        e.hasError = false;
                        e.errorPlaceholder = "";
                    }
                });
                this.customerEmails = [...this.customerEmails];
            }

            this.customerPhones = [...this.customerPhones];
        },

        addInput(type) {
            if (type === "email") {
                this.customerEmails = [...this.customerEmails, { email: "" }];
            } else if (type === "phone") {
                this.customerPhones = [
                    ...this.customerPhones,
                    { phone: "", prefix: "" },
                ];
            }
        },

        async removeInput(type, id, index) {
            if (type === "email") {
                if (!id) {
                    this.customerEmails.splice(index, 1);
                } else {
                    try {
                        await this.$store.dispatch("deleteCustomerEmail", id);
                        this.customerEmails.splice(
                            this.customerEmails.findIndex((email) => email.id === id),
                            1
                        );
                    } catch (err) {
                        console.error(err);
                    }
                }
            } else if (type === "phone") {
                if (!id) {
                    this.customerPhones.splice(index, 1);
                } else {
                    try {
                        await this.$store.dispatch("deleteCustomerPhone", id);
                        this.customerPhones.splice(
                            this.customerPhones.findIndex((phone) => phone.id === id),
                            1
                        );
                    } catch (err) {
                        console.error(err);
                    }
                }
            }
        },

        async loadCities(value) {
            await this.$store.dispatch("getZipCodeData", value);
            const currentZip = this.customerAdresses[0].zip;
            if (String(currentZip) !== String(value)) return;
            if (this.zipCodeData && this.zipCodeData.length) {
                this.customerAdresses[0].city = this.zipCodeData[0].city;
            } else {
                this.customerAdresses[0].city = "";
            }
        },

        async createCustomer() {
            const validDetails = this.validateCustomerDetails();
            const validContacts = this.validateCustomerContact();

            if (!validDetails || !validContacts) {
                return;
            }

            this.submitCustomer();
        },

        async submitCustomer() {
            this.isRequesting = true;

            const customer_emails = this.customerEmails?.[0]?.email
                ? this.customerEmails.map(e => ({
                    id: e.id,
                    email: e.email
                }))
                : [];

            const customer_phones = this.customerPhones?.[0]?.phone
                ? this.customerPhones.map(p => ({
                    id: p.id,
                    phone: p.phone,
                    prefix: p.prefix
                }))
                : [];

            const customer = {
                member_type_id: this.customerDetails.type,
                language_id: this.customerDetails.language,
                team_id: this.customerDetails.teamId,
                customer_status_id: 2,

                customer_addresses: this.customerAdresses?.[0]
                    ? [this.customerAdresses[0]]
                    : [],

                customer_emails,
                customer_phones
            };

            if (this.customerDetails.type == 2) {
                customer.first_name = this.customerDetails.firstName;
                customer.last_name = this.customerDetails.lastName;
            }

            if (this.customerDetails.type == 1) {
                customer.company_name = this.customerDetails.company;
                customer.company_type_id = 1;
            }

            if (!this.leadCustomerToEdit) {
                customer.customer_sub_status_id = 1;
            }

            try {
                if (this.leadCustomerToEdit) {
                    const customerId = this.customerEditId;

                    await this.$store.dispatch("updateLeadCustomer", {
                        customerId,
                        customerData: customer
                    });

                    if (this.$route.name === "AccountDetails") {

                        await this.$store.dispatch("getGlobalCustomer", customerId); 
                        this.$store.commit("setCustomerDetails", this.customer);
                    }

                    this.closeModal();

                } else {
                    const response = await this.$store.dispatch("createLeadCustomer", customer);

                    this.closeModal();

                    if (response?.data?.data?.id) {
                        const customerId = response.data.data.id;

                        await this.$router.push({
                            name: "AccountDetails",
                            params: {
                                entity: "lead",
                                id: customerId
                            },
                            query: {
                                tab: 10
                            }
                        });
                    }
                }

            } catch (err) {
                this.isRequesting = false;

                // Error toast is now handled by the store action
                // Keep field-specific error handling
                if (err.response?.data) {
                    let { errors } = err.response.data;

                    if (err.response.data.message) {
                        errors = err.response.data.errors || err.response.data.message;
                    }
                    this.specificErrors = this.parseFieldErrors(errors);
                }
            }
        }
    },
};
</script>

<style scoped>
.customer__form .form .add__content {
    overflow: visible !important;
}
</style>